import './App.css';
// React
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Routes, Route, NavLink } from "react-router-dom";
// bootstrap
import { Nav, Navbar } from "react-bootstrap";
// sfx utils
import { playNavSelect } from "./utils/sfx.js";
// screens
import Home from "./screens/Home.js";
import Projects from "./screens/Projects.js";
import Resume from "./screens/Resume.js";
import Events from "./screens/Events.js";

function App() {
  const location = useLocation();

  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault(); // Prevents the default right-click behavior
    };

    document.addEventListener('contextmenu', handleContextMenu);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []); // Empty dependency array ensures it runs once on mount and cleans up 

  useEffect(() => {
    document.addEventListener("keydown", (e) => {
      if (
        e.key === "F12" || // F12
        (e.ctrlKey && e.shiftKey && e.key === "I") || // Ctrl+Shift+I
        (e.ctrlKey && e.key === "U") // Ctrl+U
      ) {
        alert("👀 Interested in my code?\n✨ Let’s connect instead!\n📨 Send me a message at frances.rey@ciit.edu.ph");
        return false;
      }
    });
  }, []);

  return (
    <>
      <Navbar
        className="sidenav"
        fixed="top"
        expand="lg"
      >
        <Nav>
          <Nav.Link className={`pe-0 me-0 ${location === "/" ? "active" : ""}`} onClick={playNavSelect}>
            <NavLink className="py-3 w-black text-decoration-none" $ to="/">
              ABOUT
            </NavLink>
            {location === "/" && <div className="active-border"></div>}
          </Nav.Link>
          <Nav.Link className={`pe-0 me-0 ${location === "/projects" ? "active" : ""}`} onClick={playNavSelect}>
            <NavLink className="py-3 w-100 text-decoration-none" to="/projects">
              PROJECTS
            </NavLink>
            {location === "/projects" && <div className="active-border"></div>}
          </Nav.Link>
          <Nav.Link className={`pe-0 me-0 ${location === "/events" ? "active" : ""}`} onClick={playNavSelect}>
            <NavLink className="py-3 w-100 text-decoration-none" to="/events">
              EVENTS
            </NavLink>
            {location === "/projects" && <div className="active-border"></div>}
          </Nav.Link>
          <Nav.Link className={`pe-0 me-0 ${location === "/resume" ? "active" : ""}`} onClick={playNavSelect}>
            <NavLink className="py-3 w-100 text-decoration-none" to="/resume">
              RESUME
            </NavLink>
            {location === "/resume" && <div className="active-border"></div>}
          </Nav.Link>
        </Nav>

        <p className="copyright">© 2025 Frances Pia Alexy Rey. All rights reserved.</p>
      </Navbar>

      <div className="sidenav-borders">
        <div className="sidenav-border-1"></div>
        <div className="sidenav-border-2"></div>
        <div className="sidenav-border-3"></div>
        <div className="sidenav-border-4"></div>
        <div className="sidenav-border-5"></div>
      </div>

      <div className="page">
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/projects" element={<Projects />}></Route>
          <Route path="/resume" element={<Resume />}></Route>
          <Route path="/events" element={<Events />}></Route>

          {/* error */}
          <Route path="*" element={<p>Not found</p>} />
        </Routes>
      </div>
    </>
  );
}

export default App;